import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    HOST: "/api/",
    TOKEN: ""
  },
  mutations: {
    setToken() {
      this.state.TOKEN = window.localStorage.getItem("token");
    },
    clearToken() {
      window.localStorage.removeItem("token");
      this.state.TOKEN = "";
    }
  },
  actions: {},
  modules: {},
  strict: true
});
